/* 🤖 this file was generated by svg-to-ts */
export const matIconFilter1: {
  name: 'filter-1';
  data: string;
} = {
  name: 'filter-1',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 10h2V5h-4v2h2v8zm7-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"/></svg>`
};
